module.exports = __webpack_public_path__ + "static/media/press19.9cfd36b8.jpg";